"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _edSystem = require("@eduact/ed-system");
var _utils = require("@eduact/utils");
var _Icons = require("../../Icons");
var _react = _interopRequireWildcard(require("react"));
var _reactSpring = require("react-spring");
var _useImmer3 = require("use-immer");
var _BaseInputUtils = require("../BaseInputUtils");
var _Dropdown = require("../Dropdown/Dropdown.styled");
var _TextInput = require("../TextInput/TextInput.styles");
var _excluded = ["options", "onChange", "filterOptions", "innerRef", "placeholder", "required"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// Guards
var isObject = function isObject(value) {
  return _typeof(value) === 'object' && 'label' in value;
};
// const isArrayOf = <T,>(
// 	value: ReadonlyArray<any>,
// 	checker?: (value: T) => value is T
// ): value is Array<T> =>
// 	Array.isArray(value) &&
// 	value.length > 0 &&
// 	((checker === undefined && value.every((_) => _ instanceof T)) ||
// 		(checker !== undefined && value.every((_) => checker(_))));

var isArrayOfObjects = function isArrayOfObjects(value) {
  return Array.isArray(value) && value.length > 0 && value.every(function (_) {
    return isObject(_);
  });
};
var Autocomplete = function Autocomplete(_ref) {
  var options = _ref.options,
    onChange = _ref.onChange,
    filterOptions = _ref.filterOptions,
    _ref2 = _ref.innerRef,
    placeholder = _ref.placeholder,
    required = _ref.required,
    props = _objectWithoutProperties(_ref, _excluded);
  var innerInputRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    opened = _useState2[0],
    setOpened = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasValue = _useState4[0],
    setHasValue = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedLabel = _useState6[0],
    setSelectedLabel = _useState6[1];
  var _useElementSize = (0, _utils.useElementSize)(),
    _useElementSize2 = _slicedToArray(_useElementSize, 2),
    wrapperRef = _useElementSize2[0],
    height = _useElementSize2[1].height;
  var _useImmer = (0, _useImmer3.useImmer)(options),
    _useImmer2 = _slicedToArray(_useImmer, 2),
    filteredOptions = _useImmer2[0],
    setFilteredOptions = _useImmer2[1];
  var getOptionLabel = function getOptionLabel(option) {
    if (typeof option === 'string') return option;
    return option.label;
  };
  var handleOnChange = function handleOnChange(value) {
    if (!innerInputRef.current) return;
    setSelectedLabel(getOptionLabel(value));
    var _value;
    if (isObject(value)) {
      _value = value.id;
    } else {
      _value = value;
    }
    var evt = document.createEvent('Event');
    evt.initEvent('input', true, false);
    innerInputRef.current.value = _value.toString();
    innerInputRef.current.dispatchEvent(evt);
    onChange === null || onChange === void 0 ? void 0 : onChange(evt);
    setHasValue(true);
    setOpened(false);
  };
  var _useState7 = (0, _react.useState)(''),
    _useState8 = _slicedToArray(_useState7, 2),
    search = _useState8[0],
    setSearch = _useState8[1];
  var onSearchChange = function onSearchChange(e) {
    var value = e.target.value;
    setSelectedLabel(undefined);
    setHasValue(false);
    setSearch(value);
    var _filters = [];
    if (filterOptions) {
      var filtered = filterOptions(options, {
        value: value,
        getOptionLabel: getOptionLabel
      });
      setFilteredOptions(filtered);
    } else {
      if (isArrayOfObjects(options)) {
        _filters = options.filter(function (_) {
          return isObject(_) && _.label.includes(value);
        });
      } else {
        _filters = options.filter(function (_) {
          return typeof _ === 'string' && _.includes(value);
        });
      }
      setFilteredOptions(_filters);
    }
  };
  var outsideRef = (0, _react.useRef)(null);
  (0, _utils.useOutsideAlert)(outsideRef, function () {
    setOpened(false);
  });
  return (
    /*#__PURE__*/
    // <InputBaseWrapper>
    _react["default"].createElement("div", {
      ref: outsideRef
    }, /*#__PURE__*/_react["default"].createElement(_Dropdown.DropdownWrapper, {
      tabIndex: 0,
      $hasValue: hasValue,
      onBlur: function onBlur(e) {
        var _props$onBlur;
        (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 ? void 0 : _props$onBlur.call(props, e);
      },
      disabled: props.disabled
      // onBlur={() => setOpened(false)}
      // error={props.error}
      // {...props.sx}
    }, /*#__PURE__*/_react["default"].createElement(_TextInput.StyledInput, {
      ref: function ref(node) {
        innerInputRef.current = node;
        if (typeof _ref2 === 'function') {
          _ref2(node);
        } else if (_ref2 && node) {
          _ref2.current = node;
        }
      },
      name: props.name,
      onChange: onSearchChange,
      value: selectedLabel !== null && selectedLabel !== void 0 ? selectedLabel : search,
      placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : 'Placeholder',
      onFocus: function onFocus() {
        return setOpened(true);
      }
    }), /*#__PURE__*/_react["default"].createElement(_edSystem.FlexLayout, {
      alignItems: 'center'
    }, /*#__PURE__*/_react["default"].createElement(_Dropdown.DropdownIcon, {
      $opened: opened,
      size: 20,
      scale: 20
    }, /*#__PURE__*/_react["default"].createElement(_Icons.Icons.ChevronMore, null)), required && /*#__PURE__*/_react["default"].createElement(_BaseInputUtils.RequiredMark, null, "*")), /*#__PURE__*/_react["default"].createElement(_reactSpring.Spring, {
      config: {
        easing: _reactSpring.easings.easeInOutCirc
      },
      to: {
        maxHeight: opened ? "".concat(height, "px") : '0px'
      }
    }, function (sprintProps) {
      return /*#__PURE__*/_react["default"].createElement(_Dropdown.AnimatedWrapper, {
        style: _objectSpread(_objectSpread({}, sprintProps), {}, {
          overflow: 'hidden'
        })
      }, /*#__PURE__*/_react["default"].createElement(_Dropdown.DropdownOptions, {
        ref: wrapperRef,
        $opened: opened
      }, filteredOptions.map(function (_, index) {
        return /*#__PURE__*/_react["default"].createElement(_Dropdown.StyledDropdownOption, {
          key: "".concat(getOptionLabel(_), "-").concat(index),
          onClick: function onClick(e) {
            return handleOnChange(_);
          }
        }, getOptionLabel(_));
      })));
    })))
    // </InputBaseWrapper>
  );
};
var _default = Autocomplete;
exports["default"] = _default;